if (!customElements.get('luxsol-dimensions')) {
  customElements.define('luxsol-dimensions', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const select = this.querySelector('[data-dimension-select]');
      const panels = [...this.querySelectorAll('[data-dimension-panel]')];
      const selector = this.querySelector('[data-dimension-selector]');
      const status = this.querySelector('[data-dimension-status]');
      if (!select || !panels.length || !selector) return;
      this.initialized = true;
      const update = () => {
        panels.forEach(panel => { panel.hidden = panel.dataset.dimensionPanel !== select.value; });
        if (status) status.textContent = select.selectedOptions[0].textContent;
      };
      select.addEventListener('change', update);
      update();
      selector.hidden = false;
    }
  });
}
